import * as React from 'react';
import { Dispatch, FC } from 'react';

import { InsuranceProductState, InsuranceProgram, ProgramCode } from '../../store/types';
import { useInsuranceProduct } from './InsuranceProduct.hook';
import { BannerVariant } from '../Banner/types';
import { InsuranceProductView } from './InsuranceProductView';
import { useRenderers } from '../../../renderProps';

export interface Props {
	onToggle: Dispatch<ProgramCode>;
	onSelect: Dispatch<ProgramCode>;
	onRemove: Dispatch<ProgramCode>;
	onDownloadVskInsurance?: () => Promise<void>;
	insuranceProgram: InsuranceProgram;
	productState: InsuranceProductState;
	policyUrl?: string;
	popular: boolean;
	className?: string;
	hideForAllPassengersTextBecauseSinglePassenger?: boolean; // if there single passenger in order
	isShowImportantInsurancesError?: boolean;
	bannerVariant?: BannerVariant;
	popularPricePosition?: 'withinRadio' | 'bottom';
}

export const InsuranceProduct: FC<Props> = ({
	onToggle,
	insuranceProgram,
	productState,
	className,
	popular,
	policyUrl,
	onSelect,
	onRemove,
	onDownloadVskInsurance,
	hideForAllPassengersTextBecauseSinglePassenger,
	isShowImportantInsurancesError,
	bannerVariant = 'icon',
	popularPricePosition = 'withinRadio'
}) => {
	const model = useInsuranceProduct(insuranceProgram, onToggle, popular, productState);

	const { InsuranceProductView: InsuranceProductViewOverride = InsuranceProductView } = useRenderers();

	return (
		<InsuranceProductViewOverride
			insuranceProgram={insuranceProgram}
			className={className}
			popular={popular}
			policyUrl={policyUrl}
			onSelect={onSelect}
			onRemove={onRemove}
			onDownloadVskInsurance={onDownloadVskInsurance}
			hideForAllPassengersTextBecauseSinglePassenger={hideForAllPassengersTextBecauseSinglePassenger}
			isShowImportantInsurancesError={isShowImportantInsurancesError}
			bannerVariant={bannerVariant}
			popularPricePosition={popularPricePosition}
			showIconButton={model.showIconButton}
			isSelected={model.isSelected}
			isConfirmed={model.isConfirmed}
			isTouched={model.isTouched}
			isError={model.isError}
			handleToggle={model.handleToggle}
		/>
	);
};
